import { useRef } from "react";

export const useFocusArray = (arraySize) => {
    const focusableRefElements = [];

    for (let i = 0; i < arraySize; i += 1) {
        const elementRef = useRef(null);
        const setFocus = () => elementRef.current && elementRef.current.focus();
        focusableRefElements.push({elementRef, setFocus});
    };

    return focusableRefElements;
};